import React from "react";
import { FiChevronDown } from "react-icons/fi";
import DialCodePickerSheet from "./DialCodePickerSheet";
import { countryCodeToFlag, getDialCodeForCountry, normalizeDigits } from "../../utils/phoneUtils";
import { usePickerState } from "./PickerField";
import "./PhoneInput.css";

export default function PhoneInput({
  label,
  dialCode,
  countryCode,
  value,
  onDialCodeChange,
  onCountryCodeChange,
  onNumberChange,
  onDialPick,
  placeholder = "Phone number",
  required = false,
}) {
  const dialPicker = usePickerState();
  const flag = countryCodeToFlag(countryCode);

  const handleDialSelect = (option) => {
    if (onDialPick) {
      onDialPick(option);
      return;
    }
    onDialCodeChange?.(option.dialCode);
    onCountryCodeChange?.(option.code);
  };

  return (
    <div className="phone-input">
      {label ? (
        <span className="phone-input__label">
          {label}
          {required ? <span className="phone-input__required">*</span> : null}
        </span>
      ) : null}

      <div className="phone-input__row">
        <button
          type="button"
          className="phone-input__dial"
          onClick={dialPicker.openPicker}
          aria-label={`Country code ${dialCode}`}
        >
          <span className="phone-input__flag" aria-hidden>{flag}</span>
          <span className="phone-input__dial-code">{dialCode}</span>
          <FiChevronDown className="phone-input__dial-chevron" aria-hidden />
        </button>

        <input
          type="tel"
          className="phone-input__number"
          value={value}
          onChange={(event) => onNumberChange?.(normalizeDigits(event.target.value))}
          placeholder={placeholder}
          inputMode="tel"
          autoComplete="tel-national"
          required={required}
        />
      </div>

      <DialCodePickerSheet
        open={dialPicker.open}
        onClose={dialPicker.closePicker}
        title="Country code"
        value={dialCode}
        selectedCountryCode={countryCode}
        onSelect={handleDialSelect}
      />
    </div>
  );
}

export function PhoneInputField(props) {
  return <PhoneInput {...props} />;
}
